<template>
  <div>
  <div class="ui segment">
    <h4 class="ui horizontal divider header">
      <i class="map marker alternate icon"></i>
      Reservation Info
    </h4>

    <div class="ui form">
      <div class="fields">
        <div class="field">
          <label>Reference Code</label>
          <p>{{confirmedReservation.refCode}}</p>
        </div>
      </div>

      <div class="fields">
        <div class="field">
          <label>Pickup Time</label>
          <p>{{formatFriendlyDate(confirmedReservation.pickupDateTime)}}</p>
        </div>
      </div>

      <div class="fields" v-for="(address, index) in confirmedReservation.addresses" v-bind:key="index">
        <div class="field">
          <label>{{initialCaps(address.type)}} Address</label>
          <p>{{address.streetAddress}}, {{address.city}}, {{address.state}} {{address.zip}}</p>
        </div>
      </div>

      <div class="fields">
        <div class="field">
          <label>Vehicle Type</label>
          <p>{{initialCaps(confirmedReservation.vehicleRequest.vehicleType)}}</p>
        </div>
      </div>

      <div class="fields" v-if="confirmedReservation.clientNotes !== ''">
        <div class="field">
          <label>Additional Notes</label>
          <p>{{confirmedReservation.clientNotes}}</p>
        </div>
      </div>

    </div>

  </div>


  
  <div class="ui segment">
    <h4 class="ui horizontal divider header">
      <i class="user icon"></i>
      Contacts
    </h4>

    <div class="ui form">
      <div class="fields" v-for="(contact, index) in confirmedReservation.contacts" v-bind:key="index">
        <div class="field">
          <label>{{initialCaps(contact.type)}}</label>
          <p>{{contact.firstName}} {{contact.lastName}}<br/>
          {{contact.email}}<br/>
          {{formatUSPhone(contact.phone)}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="ui segment">
    <h4 class="ui horizontal divider header">
      <i class="file alternate outline icon"></i>
      Receipt
    </h4>

    <table class="ui two column table">
      <tbody>
        <tr v-for="(lineItem, index) in confirmedReservation.quoteInfo.lineItems" :key="index" v-if="lineItem.type !== 'total'">
          <td>{{lineItem.description}}</td>
          <td class='right aligned'>{{formatDollars(lineItem.cost)}}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr v-for="(lineItem, index) in confirmedReservation.quoteInfo.lineItems" :key="index" v-if="lineItem.type === 'total'">
          <th>{{lineItem.description}}</th>
          <th class='right aligned'>{{formatDollars(lineItem.cost)}}</th>
        </tr>
      </tfoot>
    </table>

    <table class="ui two column table">
      <tbody>
        <tr>
          <td>Payment Type</td>
          <td class='right aligned'>{{ getPaymentType() }}</td>
        </tr>
      </tbody>
    </table>

  </div>
  </div>
</template>
<script>
  import { textUtil } from './mixins/textUtil.js'

  export default {
    name: 'Confirmation',
    props: {
      reservation: Object
    },
    mixins: [textUtil],
    data: function () {
      return {
        confirmedReservation: {}
      }
    },
    methods: {
      getPaymentType: function () {
        var pType = this.reservation.payment.type
        var fType
        switch (pType) {
          case 'ACCOUNT_CODE':
            fType = 'Account Code'
            break
          case 'CC':
            fType = 'Credit Card'
            break
          default:
            fType = 'Other'
        }
        return fType
      }
    },
    mounted () {
      var v = this
      if (typeof (this.reservation) === 'undefined') {
        v.confirmedReservation = JSON.parse('{"id":4,"refCode":"BFAHSBQC","contacts":[{"firstName":"Greg","lastName":"Mertzlufft","company":"","email":"greg@bikebloc.com","phone":"(206) 679*0919","snsEnabled":null,"saved":false,"type":"PASSENGER"}],"addresses":[{"streetAddress":"123 24th Ave","city":"Seattle","state":"WA","zip":"98122","type":"PICKUP"},{"streetAddress":"17801 International Blvd","city":"Seattle","state":"WA","zip":"98158","type":"DROPOFF"}],"type":"AIRPORTDROPOFF","pickupDateTime":"2019-02-19T03:00:00Z","vehicleRequest":{"vehicleType":"SEDAN","acceptUpgrade":true},"quoteInfo":{"totalFare":68.31,"miles":15.01,"minutes":24,"lineItems":[{"type":"fare","description":"Base Fare","cost":55.53},{"type":"fuelCharge","description":"Fuel Surcharge","cost":1.67},{"type":"serviceCharge","description":"Service Charge","cost":11.11},{"type":"total","description":"Total","cost":68.31}]}}')
        // v.confirmedReservation = JSON.parse('{"refCode":"ABC123","id":17,"contacts":[{"firstName":"Test","lastName":"Passenger","company":"","email":"greg@hacksy.io","phone":"2066790919","snsEnabled":null,"type":"PASSENGER"}],"addresses":[{"streetAddress":"123 24th Ave","city":"Seattle","state":"WA","zip":"98122","type":"PICKUP"},{"streetAddress":"17801 International Blvd","city":"Seattle","state":"WA","zip":"98158","type":"DROPOFF"}],"type":"AIRPORTDROPOFF","pickupDateTime":"2018-10-11T21:20:00Z","vehicleRequest":{"vehicleType":"SEDAN","acceptUpgrade":true},"quoteInfo":{"totalFare":69.26,"miles":15.31,"minutes":24,"lineItems":[{"type":"fare","description":"Base Fare","cost":56.31},{"type":"fuelCharge","description":"Fuel Surcharge","cost":1.69},{"type":"serviceCharge","description":"Service Charge","cost":11.26},{"type":"total","description":"Total","cost":69.26}]}}')
      } else {
        v.confirmedReservation = this.reservation
      }
    }
  }
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/Confirmation.vue